<template>
  <div class="loading" v-bind:class="{ inline: inline }">{{ text }}{{ dots }}</div>
</template>

<script>
export default {
  name: 'LoadingC',
  data() {
    return {
      count: 0,
      dots: '',
    }
  },
  props: {
    inline: { default: false, required: false },
    text: { default: 'A carregar' },
  },
  created() {
    const setDots = function () {
      if (this.count < 3) {
        this.dots = this.dots + '.'
        this.count = this.count + 1
      } else {
        this.dots = ''
        this.count = 0
      }
    }
    setDots.bind(this)
    setInterval(setDots.bind(this), 500)
  },
}
</script>

<style lang="scss" scoped>
.loading {
  text-align: center;
  padding-top: 2rem;
  padding-bottom: 2rem;
  margin: auto;
}
.loading.inline {
  padding-top: 0;
  padding-bottom: 0;
  display: inline-block;
}
</style>
